<template lang="pug">

v-card.flex.d-flex.flex-column(height="100%" :outlined="Object.keys($attrs).includes('outlined') ? $attrs.outlined : true" v-bind="$attrs")
	nuxt-link(:to="localePath({name: 'trips-slug', params: { slug: slug }})")
		v-img( :src="`${image}?width=400&quality=90`" :aspect-ratio="16/9" v-ripple)
			template(#placeholder)
				v-row.fill-height(align="center" style="background-color:rgb(245,245,245);")
					v-col.text-center
						v-icon image_not_supported
	v-card-text.flex
		nuxt-link.black--text(:to="localePath({name: 'trips-slug', params: { slug: slug }})")
			h3.font-weight-bold Op wintersportvakantie naar {{name}}
		p {{introduction}}
		.text-center
			v-btn(color="primary" large depressed :to="localePath({name: 'trips-slug', params: { slug: slug }})") meer over deze wintersportreis
</template>

<script>
export default {
	name: 'TripCard',
	props: {
		name: {
			type: String,
			required: true
		},
		slug: {
			type: String,
			required: true
		},
		image: {
			type: [String, Boolean],
			default: false
		},
		introduction: {
			type: String,
			default: ''
		},
		bulletpoints: {
			type: Array,
			default() {
				return [];
			}
		},
		tags: {
			type: Array,
			default() {
				return [];
			}
		}
	}
};
</script>
